<template lang="pug">
	b-alert.mb-3(:show="true" variant="warning")
		p
			| Обратите внимание! Если стоимость вашего участия не учитывает скидку за доклад,
			| это означает, что он не выслан организатору или не находится в статусе "Подтвержден".
			| Для получения скидки&nbsp;
			a(href="#tabs" @click="switchTab( isSelectionStage && myParticipant.data.event.can_add_session ? 2 : 1, $event)") добавьте данные о докладе
</template>

<script>
	import { mapState } from 'vuex';
	import smoothScrollToEl from '@/MIXINS/smoothScrollToEl';

	export default {
		name: 't-option',
		data: () => ({

		}),
		mixins: [
			smoothScrollToEl,
		],
		computed: {
			...mapState(['myParticipant']),

			isSelectionStage(){ return this.myParticipant.data.stage.order>=this.myParticipant.data.event.selection_stage.order },
		},
		methods: {
			async switchTab(num){
				await this.$store.dispatch('changeTab', num);
				await this.smoothScrollToEl('#tabs', 65);
			},
		},
	}
</script>
